import Typography from '@mui/material/Typography';

import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/Dialog';

import { State } from '../State';

export function DialogExamples() {
  return (
    <State
      title="Opened from its trigger"
      note="Focus moves in and back, Tab stays inside, Escape and the X close it."
    >
      <Dialog
        trigger={
          <Button variant="secondary" data-testid="gallery-dialog-open-button">
            Open the dialog
          </Button>
        }
        testId="gallery-dialog-sample-dialog"
        title="A sample dialog"
        description="What it is about, read out alongside the title."
      >
        <Typography variant="body2">
          Content goes here. On a phone it fills the screen, so its buttons are never
          below the fold.
        </Typography>
      </Dialog>
    </State>
  );
}
